import React from 'react';

const Loader = ({ small }) => (
  <div className="text-center">
    <img className="demo-mw-50" style={{ width: small ? 20 : null }} src="/img/progress.svg" alt="Progress" />
  </div>
);

export default Loader;
